import React, { useEffect } from 'react';
import Hero from './Hero';
import TrustBar from './TrustBar';
import Modules from './Modules';
import DemoStrip from './DemoStrip';
import WhyChooseUs from './WhyChooseUs';
import HowItWorks from './HowItWorks';
import CTABanner from './CTABanner';
import Footer from '../../Footer';

const EducationCRMPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div style={{ fontFamily: "'Montserrat', Helvetica, Arial, sans-serif" }}>
      <Hero />
      <TrustBar />
      <Modules />
      <DemoStrip />
      <WhyChooseUs />
      <HowItWorks />
      <CTABanner />
      <Footer />
    </div>
  );
};

export default EducationCRMPage;
